/* tslint:disable */
/* eslint-disable */
/**
 * Service joined APIs
 * This is the global API definition for all service apis.
 *
 * The version of the OpenAPI document: 1.2.10
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { InternalUserReactionsEmojiResponseV3FromJSON, InternalUserReactionsEmojiResponseV3ToJSON, } from './InternalUserReactionsEmojiResponseV3';
import { CommonResponseCollectionPaginationFromJSON, CommonResponseCollectionPaginationToJSON, } from './CommonResponseCollectionPagination';
/**
 * Check if a given object implements the InternalUserReactionsEmojiResponseCollectionV3 interface.
 */
export function instanceOfInternalUserReactionsEmojiResponseCollectionV3(value) {
    if (!('pagination' in value) || value['pagination'] === undefined)
        return false;
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
export function InternalUserReactionsEmojiResponseCollectionV3FromJSON(json) {
    return InternalUserReactionsEmojiResponseCollectionV3FromJSONTyped(json, false);
}
export function InternalUserReactionsEmojiResponseCollectionV3FromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'pagination': CommonResponseCollectionPaginationFromJSON(json['pagination']),
        'data': (json['data'].map(InternalUserReactionsEmojiResponseV3FromJSON)),
    };
}
export function InternalUserReactionsEmojiResponseCollectionV3ToJSON(json) {
    return InternalUserReactionsEmojiResponseCollectionV3ToJSONTyped(json, false);
}
export function InternalUserReactionsEmojiResponseCollectionV3ToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'pagination': CommonResponseCollectionPaginationToJSON(value['pagination']),
        'data': (value['data'].map(InternalUserReactionsEmojiResponseV3ToJSON)),
    };
}
